<template>
  <div class="home"  v-if="!state.loading">
    <div class="box v-flex" style="flex-wrap:wrap">
      <div v-if="user.persona != 'Student'" class="col-lg-3 col-sm-6 mb-xl-0 box" style="padding-left: 0;">
        <div class="card">
          <router-link :to="{name:'teacherslist'}" exact>
            <div class="card-header p-2 ps-3">
              <div class="v-flex justify-content-between">
                <div>
                  <p class="text-sm mb-0 text-capitalize">Teachers</p>
                  <h4 class="mb-0"> {{ profile.teachers }} </h4>
                </div>
                <div class="iconwrap">
                  <div class="ic">
                    <div v-html="icons['users']"></div>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div v-if="user.persona != 'Student'" class="col-lg-3 col-sm-6 mb-xl-0 box" style="padding-left: 0;" >
        <div class="card">
          <router-link :to="user.persona == 'Admin' ? { name: 'students' } : {name: 'teacherstudents', params: { id: user.username }}">
            <div class="card-header p-2 ps-3">
              <div class="v-flex justify-content-between">
                <div>
                  <p class="text-sm mb-0 text-capitalize">Students</p>
                  <h4 class="mb-0"> {{ profile.students }} </h4>
                </div>
                <div class="iconwrap">
                  <div class="ic">
                    <div v-html="icons['users']"></div>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div v-if="user.persona != 'Student'" class="col-lg-3 col-sm-6 mb-xl-0 box" style="padding-left: 0;">
        <div class="card">
          <div class="card-header p-2 ps-3">
            <div class="v-flex justify-content-between">
              <div>
                <p class="text-sm mb-0 text-capitalize">Past Students</p>
                <h4 class="mb-0"> {{ profile.past_students }} </h4>
              </div>
              <div class="iconwrap">
                <div class="ic">
                  <div v-html="icons['users']"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="user.persona != 'Student'" class="col-lg-3 col-sm-6 mb-xl-0 box" style="padding-left: 0;">
        <div class="card">
          <router-link :to="{name:'subjectlist'}" exact>
            <div class="card-header p-2 ps-3">
              <div class="v-flex justify-content-between">
                <div>
                  <p class="text-sm mb-0 text-capitalize">Subjects</p>
                  <h4 class="mb-0"> {{ profile.subjects }} </h4>
                </div>
                <div class="iconwrap">
                  <div class="ic">
                    <div v-html="icons['users']"></div>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div v-if="user.persona == 'Student'" class="col-lg-3 col-sm-6 mb-xl-0 box" style="padding-left: 0;">
        <div class="card">
          <router-link :to="{name:'assignmentlist'}" exact>
            <div class="card-header p-2 ps-3">
              <div class="v-flex justify-content-between">
                <div>
                  <p class="text-sm mb-0 text-capitalize">Assignments</p>
                  <h4 class="mb-0"> {{ profile.assignment }} </h4>
                </div>
                <div class="iconwrap">
                  <div class="ic">
                    <div v-html="icons['dashboard']"></div>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div v-if="user.persona != 'Student'" class="col-lg-3 col-sm-6 mb-xl-0 box" style="padding-left: 0;" >
        <div class="card">
          <router-link :to="{name: 'birthdays', params: { type: 'today' }}">
            <div class="card-header p-2 ps-3">
              <div class="v-flex justify-content-between">
                <div>
                  <p class="text-sm mb-0 text-capitalize">Today's Birthday</p>
                  <h4 class="mb-0"> {{ profile.birthday }} </h4>
                </div>
                <div class="iconwrap">
                  <div class="ic">
                    <div v-html="icons['birthday']"></div>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div><div v-if="user.persona == 'Admin'" class="col-lg-3 col-sm-6 mb-xl-0 box" style="padding-left: 0;" >
        <div class="card">
          <router-link :to="{name: 'birthdays', params: { type: 'month' }}">
            <div class="card-header p-2 ps-3">
              <div class="v-flex justify-content-between">
                <div>
                  <p class="text-sm mb-0 text-capitalize">Birthdays this {{currentMonth}}</p>
                  <h4 class="mb-0"> {{ profile.mbirthday }} </h4>
                </div>
                <div class="iconwrap">
                  <div class="ic">
                    <div v-html="icons['birthday']"></div>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
</template>

<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import icons from '@/assets/js/icons.js';
import {  ref,reactive,onMounted,computed} from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'HomeView',
  setup(){
    const store= useStore();
    const user = computed(() => store.state.User.user);
    const svgIcons = ref(icons);
    const state=reactive({loading:true})
    const profile=ref({teachers:0,past_students:0,students:0,subjects:0,assignment:0, birthday:0,mbirthday:0})
    const currentMonth = ref(new Date().toLocaleString('default', {
      month: 'long'
    }));
    onMounted(() => {
        call({
            url:urls.dashboard,
            data:{getSummary:""},
            success:(res)=>{
                state.loading=false
                if(res.status){
                  var msg=res.msg;
                  var data=msg.summary;
                  profile.value={teachers:data.teachers, past_students:data.past_students, students:data.students, 
                    subjects:data.subjects, assignment:data.assignment, birthday:data.birthday,mbirthday:data.mBirthday}
                }else{
                    alert(res.msg);
                }
            }
        })
    });
    return{icons: svgIcons.value, state,profile, user,currentMonth}
  }
}
</script>

<style scoped>
.box{padding: 0 calc(1.5rem* 0.5);}
.font-weight-bolder{font-weight: bolder;}
p{color:var(--light-text-color) !important; font-family: Inter, Helvetica, Arial, sans-serif;}
.box > *{padding: 0 calc(1.5rem * 0.5);}
.box .card{background:var(--white-color); border-radius: 0.5rem}
.card-header:first-child {border-radius: 0.5rem 0.5rem 0 0;padding: 0.5rem !important;
  padding-left: 1rem !important;background-color: var(--white-color);
  border-bottom: 0 solid #e5e5e5;}
.iconwrap{border-radius: 0.5rem; width: 48px;height: 48px; background-position: center;
  background-image: var(--black-gradient);
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(64, 64, 64, 0.4) !important;
  text-align: center !important; display: flex; align-items: center; justify-content: center;}
.iconwrap .ic{width:18px; height:18px; fill:var(--always-white);line-height: 0em;
    stroke: var(--always-white);}
.text-sm {font-size: 0.875rem !important; line-height: 1.5;}
.text-capitalize {text-transform: capitalize !important;}
h4{font-size: 1.5rem; line-height: 1.375; font-weight: 600;}
hr.horizontal {background-image: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.4), transparent);}
body.dark-mode hr.horizontal{background-image: linear-gradient(90deg, hsla(0, 0%, 100%, 0), #fff, hsla(0, 0%, 100%, 0));}
.my-0 {margin-top: 0 !important; margin-bottom: 0 !important;}
hr.horizontal {background-color: transparent;}
hr {border-top: none; height: 1px;}
hr {color: inherit; border: 0; opacity: 0.25;}
.ps-3 {padding-left: 1rem !important;}
.p-2 {padding: 0.5rem !important;}
</style>
